import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/types";
import { createBulkHours } from "@/api/capex/createBulkHours/createBulkHoursApi";
import { BulkHoursResult } from "@/types/capex";

interface BulkHoursState {
  result: BulkHoursResult | null;
  loading: boolean;
  error: string | null;
}

const initialState: BulkHoursState = {
  result: null,
  loading: false,
  error: null,
};

export const bulkHoursSlice = createSlice({
  name: "bulkHours",
  initialState,
  reducers: {
    setResult(state, action: PayloadAction<BulkHoursResult | null>) {
      state.result = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

export default bulkHoursSlice.reducer;

export const { setResult, setLoading, setError, resetState } =
  bulkHoursSlice.actions;

// Thunks
export const createBulkHoursAction =
  (pbiIds: number[], title: string, dueDate: string): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    dispatch(setResult(null));

    try {
      const result = await createBulkHours({ pbiIds, title, dueDate });
      dispatch(setResult(result));
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to create bulk hours";
      dispatch(setError(message));
    } finally {
      dispatch(setLoading(false));
    }
  };
